import React, {useContext, useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import {FormProvider} from "react-hook-form";
import TextFieldControl from "../../../../Controls/Inputs/TextFieldControl";
import strings from "../../../../../localization";
import TablePageContext from "../../../../../Context/TablePageContext";
import PageState from "../../../../../Constants/Base/PageState";
import CheckBoxControl from "../../../../Controls/Inputs/CheckBoxControl";
import FileUploadComponent from "../../../../Controls/FileUploadComponent";
import {toBase64} from "../../../../../Util/ImageUtil";
import AutoCompleteControl from '../../../../Controls/Inputs/AutoCompleteControl';
import { mbToBytes } from '../../../../../Util/FileUtil';
import {ImageFormats} from "../../../../../Constants/FileFormat";

const AssetTypeForm = ({
                         onSubmit,
                         onCancel,
                         data,
                         form,
                         errors,
                         vendors,
                         categories,
                         values,
                         setValue,
                         formRules,
                         control,
                         onVendorChangeFilter,
                         onAssetCategoryChangeFilter,
                     }) => {
    const [disabledSubmit, setDisabledSubmit] = useState(false);
    const [imagePreview, setImagePreview] = useState(values['image']);
    const [files, setFiles] = useState([]);
    const {pageState} = useContext(TablePageContext);
    const isPageStateViewDetails = () => pageState === PageState.ViewDetails;
    

    const uploadLogo = async (files) => {
        setDisabledSubmit(true)
        const logo = await toBase64(files[0]);
        setValue('image', logo);
        setImagePreview(logo)
        setDisabledSubmit(false)
    }

    return (
        <FormProvider {...form}>
            <form id='asset-type-form' className='form' action="#">
                <TextFieldControl
                    name='name'
                    rules={formRules['name']}
                    control={data}
                    error={Boolean(errors.name)}
                    helperText={errors.name && strings.forms.common.thisFieldIsRequired}
                    label={strings.forms.assetManagement.assetType.name}
                    disabled={isPageStateViewDetails()}
                />

                <TextFieldControl
                    name='description'
                    rules={formRules['description']}
                    control={data}
                    label={strings.forms.assetManagement.assetType.description}
                    disabled={isPageStateViewDetails()}
                />
                
                <TextFieldControl
                    name='price'
                    rules={formRules['price']}
                    control={data}
                    type="number"
                    label={strings.forms.assetManagement.assetType.price}
                    disabled={isPageStateViewDetails()}
                />

                <TextFieldControl
                    name='tax'
                    rules={formRules['tax']}
                    control={data}
                    type="number"
                    label={strings.forms.assetManagement.assetType.tax}
                    disabled={isPageStateViewDetails()}
                />

                <CheckBoxControl
                    name={'canReturnTax'}
                    control={data}
                    label={strings.forms.assetManagement.assetType.canReturnTax}
                    value={values['canReturnTax']}
                    setValue={setValue}
                    disabled={isPageStateViewDetails()}
                />

                <AutoCompleteControl
                    value={values['vendor']}
                    setValue={setValue}
                    name='vendor'
                    control={control}
                    label={strings.forms.assetManagement.assetType.vendor}
                    options={vendors}
                    nameKey={'name'}
                    valueKey={'id'}
                    disabled={isPageStateViewDetails()}
                    onChange={onVendorChangeFilter}
                    onOpen={() =>onVendorChangeFilter('')}
                />

                <AutoCompleteControl
                    value={values['assetCategory']}
                    setValue={setValue}
                    name='assetCategory'
                    control={control}
                    label={strings.forms.assetManagement.assetType.assetCategory}
                    options={categories}
                    nameKey={'name'}
                    valueKey={'id'}
                    disabled={isPageStateViewDetails()}
                    onChange={onAssetCategoryChangeFilter}
                    onOpen={() =>onAssetCategoryChangeFilter('')}
                />

                {!isPageStateViewDetails() && <FileUploadComponent hideUploadButton={true} onDrop={uploadLogo} formats={ImageFormats} files = {files} setFiles = {setFiles} />}
                    <div className='logo'>
                        {imagePreview && <img src={imagePreview} width={200}/>}
                    </div>                   

                {
                    !isPageStateViewDetails() && <div className='submit-container'>
                        <Button variant="contained" color="primary" disabled={disabledSubmit} onClick={onSubmit}>
                            {strings.forms.common.save}
                        </Button>
                        <Button variant="contained" color="secondary" onClick={onCancel}>
                            {strings.forms.common.cancel}
                        </Button>
                    </div>
                }
            </form>
        </FormProvider>
    );
}

export default AssetTypeForm;
